import { useState } from 'react';

const faqs = [
  {
    q: '合作的最低起訂量是多少？',
    a: '依據不同劑型與配方複雜度，最低起訂量有所不同。一般膠囊最低起訂量約為 30,000 顆 ，歡迎洽詢業務人員確認您的需求。',
  },
  {
    q: '我只有產品構想但沒有配方，可以合作嗎？',
    a: '完全可以！康永生技提供完整的 ODM 服務，您只需提供品牌定位、目標族群及功效訴求，我們的研發團隊將為您量身打造配方，無需具備任何技術背景。',
  },
  {
    q: '合作過程中我的配方會被保護嗎？',
    a: '是的。我們在合作開始前即簽訂嚴格的 NDA（保密協議），您的配方、商業計劃及所有技術資訊均受到完善保護，絕不外流。',
  },
  {
    q: '樣品確認到正式量產需要多長時間？',
    a: '從初步諮詢到樣品完成約需 3～6 週；樣品確認後進入量產，生產週期視訂單規模約需 4～8 週。完整時程將依您的產品複雜度與訂單量而定。',
  },
  {
    q: '是否可以協助包裝設計與標示審查？',
    a: '是的，康永提供包裝設計建議與標示內容審查服務，協助客戶確認符合台灣健康食品相關法規，確保產品能合法上架銷售。',
  },
  {
    q: '如何確認合作後的產品品質？',
    a: '每批次生產均會進行完整的品管檢驗，並出具完整的批次檢驗報告 也能提供產品出廠檢驗報告 ，確保每批產品符合規格標準。',
  },
  {
    q: '可以幫我的產品做出口嗎？',
    a: '可以，康永生技可協助準備出口所需文件，並確認產品符合目標市場的相關規範。',
  },
  {
    q: '第一次合作要如何開始？',
    a: '最簡單的方式是透過官網聯絡表單、LINE 或電話聯繫我們的業務團隊，說明您的初步需求，業務人員將盡快回覆並安排進一步溝通。',
  },
];

export default function PartnershipFaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            常見問題
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            合作前最常問的問題
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            我們整理了最常見的合作疑問，如有其他問題歡迎直接聯絡我們
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${
                openIdx === idx ? 'border-[#4CAF50]/40' : 'border-gray-100'
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <span
                  className={`text-[1rem] font-semibold leading-snug pr-4 ${
                    openIdx === idx ? 'text-[#4CAF50]' : 'text-[#1a2e1a]'
                  }`}
                >
                  {faq.q}
                </span>
                <div
                  className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${
                    openIdx === idx ? 'bg-[#4CAF50] text-white' : 'bg-green-50 text-[#4CAF50]'
                  }`}
                >
                  <i className={`text-sm ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`} />
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 text-[0.9375rem] leading-[1.75]">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
